<template>
	<article class="d-about-page">
		<header
			v-if="title || name || teaser"
			class="text-white w-full px-layout-margin pt-[35px] mb-[50px]"
		>
			<h1
				v-if="title || name"
				class="text-45 font-light mb-[10px]"
				v-html="title || name"
			></h1>

			<p
				v-if="teaser"
				class="whitespace-pre-line text-22"
				v-html="teaser"
			></p>
		</header>

		<ul
			class="w-full >=568:px-layout-margin grid grid-cols-1 >=760:grid-cols-2 >=990:grid-cols-3 gap-layout-gutter auto-rows-fr"
		>
			<!-- The tile for the current page -->
			<li v-if="infoBox" key="infoBox" class="bg-green p-box-padding">
				<h2
					v-if="infoBox.title"
					class="text-20 font-bold mb-paragraph"
					v-html="infoBox.title"
				></h2>

				<div
					v-if="infoBox.text"
					class="s-rich-text mb-paragraph"
					v-html="infoBox.text"
				></div>

				<footer
					v-if="infoBox.link && infoBox.link.name"
					class="my-paragraph"
				>
					<NuxtLink
						:to="infoBox.link.url"
						:target="infoBox.link.target"
						class="underline text-text hover:text-opacity-80 transition-colors duration-300"
						>{{ infoBox.link.name }}</NuxtLink
					>
				</footer>
			</li>

			<!-- Items -->
			<li
				v-for="(item, index) in items"
				:key="index"
				class="bg-white p-box-padding"
			>
				<NuxtLink
					v-if="item.url && item.name"
					:to="item.url"
					class="inline-block underline text-text hover:text-opacity-80 transition-colors duration-300 mb-paragraph"
				>
					<h2 class="text-20 font-bold" v-html="item.name"></h2>
				</NuxtLink>
				<h2
					v-else-if="item.name"
					class="text-20 font-bold mb-paragraph"
					v-html="item.name"
				></h2>

				<div
					v-if="item.teaser"
					class="s-rich-text whitespace-pre-line mb-paragraph"
					v-html="item.teaser"
				></div>
			</li>
		</ul>
	</article>
</template>

<script>
export default {
	inheritAttrs: false,
};
</script>

<script setup>
const props = defineProps({
	title: String,
	name: String,
	teaser: String,
	boxTitle: String,
	boxText: String,
	boxLink: String,
	items: Array,
});

const infoBox = computed(() => {
	return props.boxTitle || props.boxTitle || props.boxLink
		? {
			title: props.boxTitle,
			text: props.boxText,
			link: props.boxLink,
		  }
		: null;
});
</script>

<style lang="postcss">
.d-about-page {
	@apply w-full max-w-layout-max pb-[80px] mx-auto;
}
</style>
